import { cn } from "@/lib/utils";

export const ResizeHandle = ({
  onMouseDown,
  className,
}: {
  onMouseDown: (e: React.MouseEvent) => void;
  className?: string;
}) => (
  <div
    role="separator"
    aria-orientation="vertical"
    onMouseDown={onMouseDown}
    onClick={(e) => e.stopPropagation()}
    className={cn(
      "absolute right-0 top-0 h-full w-1 z-10 cursor-col-resize select-none",
      "bg-primary/50 transition-opacity",
      className,
    )}
  />
);
